import hotel from "../assets/images/screenshots/Hotel.png";
import coffee from "../assets/images/screenshots/Coffee.png";
import jobListings from "../assets/images/screenshots/JobListings.jpg";
import bank from "../assets/images/screenshots/Easybank.png";
import pricing from "../assets/images/screenshots/Pricing.png";
import countries from "../assets/images/screenshots/Countries.png";

export const PROJECT_INFORMATION = [
  {
    id: 0,
    image: hotel,
    title: "Hotelnut Web App",
    description: "A Hotel Booking Web App built on the MERN stack.",
    siteLink: "https://hotelnut.zawwarahmed.com",
    codeLink: "https://github.com/SyedZawwarAhmed/Hotel-Booking-Web-App",
  },
  {
    id: 1,
    image: coffee,
    title: "Coffeeroasters Subscription Site",
    description:
      "This is a multipage coffee subscription site made using HTML, CSS and Vanilla JavaScript.",
    siteLink: "https://coffeeroasters.zawwarahmed.com",
    codeLink:
      "https://github.com/SyedZawwarAhmed/coffeeroasters-subscription-site",
  },
  {
    id: 2,
    image: countries,
    title: "Countries of the World",
    description:
      "This application displays information about all the countries of the world by integrating with a REST API.",
    siteLink: "https://countries.zawwarahmed.com",
    codeLink: "https://github.com/SyedZawwarAhmed/Countries-of-the-World",
  },
  {
    id: 3,
    image: jobListings,
    title: "Static Job Listings",
    description:
      "This is a Reactjs site which shows programming jobs from a data file and those jobs can be filtered based on the role, level and programming languages.",
    siteLink: "https://joblistings.zawwarahmed.com",
    codeLink: "https://github.com/SyedZawwarAhmed/static-job-listings",
  },
  {
    id: 4,
    image: bank,
    title: "Easybank Landing Page",
    description:
      "This is a landing page website for a bank made using HTML, CSS and a little bit of JavaScript.",
    siteLink: "https://easybank.zawwarahmed.com",
    codeLink: "https://github.com/SyedZawwarAhmed/easybank-landing-page",
  },
  {
    id: 5,
    image: pricing,
    title: "Interactive Pricing Component",
    description:
      "This is a simple project which gives a pricing plan based on user preferences.",
    siteLink: "https://pricing.zawwarahmed.com",
    codeLink:
      "https://github.com/SyedZawwarAhmed/interactive-pricing-component",
  },
];
